import { initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider } from 'firebase/auth';

const firebaseConfig = {
  apiKey:            'AIzaSyB0OspHwEqES4zzdTCjaUQA2_jGZu1bHBE',
  authDomain:        'hafiz-store-823f8.firebaseapp.com',
  projectId:         'hafiz-store-823f8',
  storageBucket:     'hafiz-store-823f8.firebasestorage.app',
  messagingSenderId: '273815720525',
  appId:             '1:273815720525:web:9f5cdf0d8b26889f184204',
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();
